import React, { SetStateAction } from 'react';
import styled from 'styled-components';
import { BiCalendar } from 'react-icons/bi';
import { FiFileText } from 'react-icons/fi';
import formatPrice from '../../services/utils/formatPrice';
import getContractDescription from '../../utils/getContractDescription';
import getOriginalContract from '../../utils/getOriginalContract';

const DebtInfoRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  h2.title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    color: #070c2f;
    margin-bottom: 8px;
  }
  span.creditor {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: #7b86a3;
    margin-bottom: 2px;
  }

  div.options {
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
  }

  span.label {
    font-family: Font Awesome 5 Free;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #7b86a3;
    margin: 0 2px 0 4px;
  }

  span.contract {
    font-weight: bold;
  }
  span.contracts {
    text-decoration: underline;
    margin-left: 4px;
    color: blue;

    :hover {
      cursor: pointer;
    }
  }
`;

interface IDebtInfo {
  creditor: string;
  currentDealValue: number;
  contractsToShow: string | GQL.IContractDetails;
  multipleContracts: boolean;
  dueDate: string;
  debtDetails: string;
  openModal: React.Dispatch<SetStateAction<boolean>>;
}

const DebtInfo: React.FC<IDebtInfo> = ({
  creditor,
  currentDealValue,
  contractsToShow,
  multipleContracts,
  dueDate,
  debtDetails,
  openModal,
}) => {
  return (
    <DebtInfoRoot>
      <h2 className='title'>{`Valor atual da dívida: R$ ${formatPrice(
        currentDealValue
      )}`}</h2>
      <span className='creditor'>{creditor}</span>

      <div className='options'>
        <FiFileText />
        <span className='label'>
          {multipleContracts ? 'Múltiplos contratos: ' : 'Contrato: '}
        </span>

        {!multipleContracts && (
          <span className='contract'>
            {getOriginalContract(contractsToShow)}
          </span>
        )}
        {multipleContracts && (
          <span className='contracts' onClick={() => openModal(true)}>
            Clique para exibir
          </span>
        )}
      </div>

      <div className='options'>
        <BiCalendar />

        <span className='label'>Vencimento:</span>
        <span className='contract'> {dueDate} </span>
      </div>

      {debtDetails && debtDetails !== '' && (
        <span dangerouslySetInnerHTML={{ __html: debtDetails }} />
      )}

      {multipleContracts && (
        <span className='contentInfo' style={{ wordBreak: 'break-word' }}>
          {getContractDescription(contractsToShow)}
        </span>
      )}
    </DebtInfoRoot>
  );
};

export default DebtInfo;
